'use strict';

angular.module('TurneroApp').component('coTrsTramite', {
    bindings: {
        idTramiteRelevado: '<',
        ctrlPadre: '=',
        idAgenda: '<',
        asistencia: '<',
        ciudadano: '<'
    },
    controller: [
		  'utilsService',
		  'TurneroAppConstant',
		  'TRSService',
		  function (utilsService, TurneroAppConstant, TRSService) {
		      var ctrl = this;

		      ctrl.$onChanges = function () {
		          if (ctrl.idTramiteRelevado && ctrl.idAgenda && ctrl.ciudadano != undefined) {
		              ctrl.GetTasas();
		              ctrl.ctrlPadre.GenerarTasas = ctrl.GenerarTasas;
		              ctrl.ctrlPadre.limpiarTasas = ctrl.limpiarTasas;
		          }
		      }


		      ctrl.validarCampos_Requerido = function (Campos) {
		          ctrl.errorEmail = false;
		          if (Campos && Campos.length) {
		              for (var i = 0; i < Campos.length; i++) {
		                  var concepto = Campos[i]
		                  Campos[i].errores = false;
		                  if (!concepto.N_Valor && (concepto.Flag_Cantidad == 'S' || concepto.Flag_Importe == 'S')) {
		                      Campos[i].errores = true;
		                      return false;
		                  }
		                  if (concepto.N_Valor && concepto.Flag_Cantidad == 'S') {
		                      if (!concepto.N_Valor || concepto.N_Valor < 0 || concepto.N_Valor < concepto.Cantidad_Desde || concepto.N_Valor > concepto.Cantidad_Hasta) {
		                          swal('Valor de concepto erroneo', 'El valor del concepto :' + concepto.n_concepto + ' no esta dentro de los valores permitidos. <br/> Valor minimo:' + concepto.Cantidad_Desde + '<br/> Valor maximo:' + concepto.Cantidad_Hasta, 'warning')
		                          return false;
		                      }
		                  }
		                  if (concepto.N_Valor && concepto.Flag_Importe == 'S') {
		                      if (!concepto.N_Valor || concepto.N_Valor < 0) {
		                          swal('Valor de concepto erroneo', 'El valor del concepto :' + concepto.n_concepto + ' no puede ser menor a 0.', 'warning')
		                          return false;
		                      }
		                  }
		              }
		              if ((!ctrl.ciudadano) && !ctrl.ctrlPadre.EmailTasas) {
		                  ctrl.errorEmail = true;
		                  return false;
		              }
		          }
		          return true
		      }
		      ctrl.GenerarTasas = function () {
		          ctrl.input_tasas = null;
		          if (ctrl.validarCampos_Requerido(ctrl.tasasTramite)) {
		              var Campos = ctrl.tasasTramite;
		              ctrl.input_tasas = null;
		              if (Campos && Campos.length) {
		                  for (var i = 0; i < Campos.length; i++) {
		                      var tasaItem = Campos[i]
		                      var item = tasaItem.Cod_Ente + ';' + tasaItem.Id_Concepto + ';' + (tasaItem.Flag_Cantidad == 'S' ? tasaItem.N_Valor : 'null') + ';' + (tasaItem.Flag_Importe == 'S' ? tasaItem.N_Valor : 'null')
		                      ctrl.input_tasas = ctrl.input_tasas ? (ctrl.input_tasas + '|' + item) : item;
		                  }
		              }
		              ctrl.ctrlPadre.input_Tasas_Tramite = ctrl.input_tasas;
		              return true;
		          }
		          return false;

		      }
		      ctrl.Cancelar = function () {
		          ctrl.ctrlPadre.cancelar();
		      }


		      ctrl.GetTasas = function () {
		          ctrl.loadingTasas = true;
		          TRSService.Get_Tasas_Tramite({ 'Id_Tramite_Relevado': ctrl.idTramiteRelevado, 'Id_Agenda': ctrl.idAgenda }).$promise.then(function (resultado) {
		              ctrl.ctrlPadre.d3.resolve();
		              ctrl.tasasTramite = resultado.Data;
		              ctrl.showTasas = ctrl.tasasTramite.length ? true : false;
		              ctrl.loadingTasas = false;
		              ///	$scope.$apply();
		          }).catch(function (error) {
		              ctrl.ctrlPadre.d3.resolve();
		              ctrl.loadingTasas = false;
		              utilsService.errores(error);
		          });
		      }
		      ctrl.limpiarTasas = function () {
		          if (ctrl.tasasTramite) {
		              for (var i = 0; i < ctrl.tasasTramite.length; i++) {
		                  ctrl.tasasTramite[i].N_Valor = null;
		              }
		          }

		      }

		  }],
    template: require('./trsTramite.html')
});



// WEBPACK FOOTER //
// ./app/components/trs/trsTramiteComponent.js